import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const widgetsSupervisionModal: ThemeUICSSObject = {
  /* PREPEND HERE */

  '.collector__buttons': {
    button: {
      background: 'red !important',
    },
  },
};

export default widgetsSupervisionModal;
